<xi-drawer
  #drawer
  [open]="drawerOpen"
  [interceptClose]="true"
  (onClose)="cancel()"
  color="CX"
  [silverBg]="true"
>
  <ng-container *transloco="let t; read: 'project-options'">
    <div slot="title">{{ t('title') }}</div>

    <div slot="body">
      <div class="project-options__tab-bar-wrapper">
        <xi-horizontal-tab-bar
          [data]="tabs"
          [(activeTabId)]="activeTab"
          [hasTransparentBackground]="true"
          [tabSpacing]="25"
          color="CX"
        >
        </xi-horizontal-tab-bar>
      </div>
      <div class="project-options__tab-bar-keyline"></div>

      <div
        [ngClass]="
          activeTab === 'general'
            ? 'project-options-drawer__tab--visible'
            : 'project-options-drawer__tab--hidden'
        "
      >
        <div class="project-options__content-with-padding">
          <div class="general_description">
            <h4>{{ t('basic-settings-header') }}</h4>

            <p>{{ t('basic-settings-content') }}</p>
          </div>

          <div class="general_inputs">
            <div class="project-view__project-name--edit">
              <xi-input-field
                [placeholder]="t('enter-project-name')"
                [label]="t('project-name')"
                [(ngModel)]="name"
                [maxCharsAllowed]="{ max: 64, allowOvertype: false, errorMessage: '' }"
                [status]="projectNameStatus"
                [prePopulateStatus]="true"
                (onChange)="onValidateProjectName()"
                [disabled]="isReadOnly"
              ></xi-input-field>
            </div>

            <div class="project-view__project-description--edit">
              <xi-text-area
                [placeholder]="t('enter-project-description')"
                [label]="t('project-description')"
                [(ngModel)]="description"
                name="project-description"
                [height]="100"
                hasMaxCharsAllowed="true"
                [prePopulateStatus]="true"
                [maxCharsAllowed]="{ max: 256, allowOvertype: false, errorMessage: '' }"
                [disabled]="isReadOnly"
              ></xi-text-area>
            </div>
          </div>
        </div>

        <div class="project-options__content">
          <app-project-icon
            [(iconUrl)]="icon"
            [isReadOnly]="isReadOnly"
            [isAdmin]="isAdmin"
          ></app-project-icon>
        </div>
      </div>

      <div
        [ngClass]="
          activeTab === 'configurations'
            ? 'project-options-drawer__tab--visible'
            : 'project-options-drawer__tab--hidden'
        "
      >
        <div class="configuration-list__table-section-container">
          <div class="project-options__content">
            <div class="configuartion-list_top-top">
              <h4>{{ t('configurations-header') }}</h4>

              <p>{{ t('configurations-content') }}</p>
            </div>

            <div class="project-options__table-wrapper">
              <div class="configuration-list__top-section">
                <div class="configuration-list__header-wrapper">
                  <h2 class="kxi-text-large">
                    {{ t('configurations') }}
                    <span>
                      {{ t('numberof-results', { count: filteredConfigs?.length }) }}
                    </span>
                  </h2>
                </div>
              </div>

              <app-configuration-table
                [displayedColumns]="displayedColumns"
                [configCreatorMap]="configCreatorMap"
                [configurations]="filteredConfigs"
              ></app-configuration-table>
            </div>
          </div>
        </div>
      </div>

      <app-project-sentiment-range
        [ngClass]="
          activeTab === 'adjust-sentiment-ranges'
            ? 'project-options-drawer__tab--visible'
            : 'project-options-drawer__tab--hidden'
        "
        [project]="project"
        [readOnly]="isReadOnly"
        [embeddedButtons]="false"
      ></app-project-sentiment-range>

      <div
        [ngClass]="
          activeTab === 'color-palette'
            ? 'project-options-drawer__tab--visible'
            : 'project-options-drawer__tab--hidden'
        "
      >
        <div class="project-options__colors-wrapper">
          <div class="project-options__colors">
            @if (!isReadOnly) {
              <xi-icon-button
                icon="plus"
                [disabled]="colorPalette.length >= PROJECT_COLOR_LIMIT"
                [tooltip]="{ text: addColorTooltip }"
                [tooltipDisplayOnDisabled]="true"
                (onClick)="onAddColor()"
              ></xi-icon-button>
            }

            <div class="project-options__color-grid">
              @for (color of colorPalette; track trackColors(i); let i = $index) {
                <app-color-box
                  [canDelete]="!isReadOnly && colorPalette.length > 1"
                  [canEdit]="!isReadOnly"
                  [color]="color"
                  (colorChange)="onColorChanged(i, $event)"
                  (colorDelete)="onColorDeleted(i)"
                ></app-color-box>
              }
            </div>
          </div>

          <div class="project-options__color-actions">
            @if (!isReadOnly) {
              <xi-default-button
                [text]="t('reset-palette')"
                [disabled]="!canResetColorPalette"
                (onClick)="resetColorPalette()"
              ></xi-default-button>
            }

            <xi-default-button
              [text]="t('copy-palette')"
              (onClick)="onCopyColorPalette()"
            ></xi-default-button>

            @if (!isReadOnly) {
              <xi-default-button
                [text]="t('import-palette')"
                (onClick)="showImportColorPaletteDialog = true"
              ></xi-default-button>
            }
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="footer">
      <div>
        <span class="project-view__cancel-button">
          <xi-default-button
            [text]="t('cancel')"
            fill="text"
            [disabled]="!!isLoading.saveEdit"
            (onClick)="cancel()"
          ></xi-default-button>
        </span>

        @if (!isReadOnly) {
          <xi-default-button
            [text]="t('confirm')"
            [disabled]="!canSave"
            (onClick)="save()"
          ></xi-default-button>
        }
      </div>
    </div>
  </ng-container>
</xi-drawer>

@if (showImportColorPaletteDialog) {
  <app-lex-xi-modal
    [isVisible]="showImportColorPaletteDialog"
    (close)="onImportColorPaletteModalClosed()"
  >
    <ng-template appXIModalContent>
      @if (showImportColorPaletteDialog) {
        <app-color-palette-import-dialog
          (modalClosed)="onImportColorPaletteModalClosed($event)"
        ></app-color-palette-import-dialog>
      }
    </ng-template>
  </app-lex-xi-modal>
}
